/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerApprovalResponse } from "./MemberManagerApprovalResponse";

export type MemberManagerApprovalResponseApiRespoonse = {
  data?: MemberManagerApprovalResponse;
  status?: MemberManagerApprovalResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerApprovalResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
